import BangKeoKQV2 from "../BangKeoKQV2";

const KbvBangKeoKetQuaV3 = () => <BangKeoKQV2 type="ketqua" />;

export default KbvBangKeoKetQuaV3;